import React from "react"
import { observer, useLocalObservable } from "mobx-react"
import { Flex, Table } from "antd"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { TransactionsOutEmpty } from "@src/pages/transactionsOut/constants"
import { RefundsCollection } from "@src/pages/transactionsRefunds/classes/RefundsCollection"
import { RefundsColumns } from "@src/pages/transactionsRefunds/constants"
import { RefundsTableExpandable } from "@src/pages/transactionsRefunds/RefundsTableExpandable"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsRefundsPage = observer(() => {
  const payments = useLocalObservable(() => new RefundsCollection())

  return (
    <Flex gap={16} vertical>
      <TableFilters {...payments.filter.props} />
      {choose(
        [payments.isLoading && payments.isEmpty, <LoadingBlock />],
        [payments.isEmpty, <TransactionsOutEmpty />],
        [
          !payments.isEmpty,
          <Table
            columns={RefundsColumns}
            dataSource={payments.items}
            expandable={{
              expandedRowRender: (record) => (
                <RefundsTableExpandable
                  isLoading={payments.isLoading}
                  payment={record}
                />
              ),
            }}
            loading={payments.isLoading}
            pagination={payments.pagination}
            rowKey="id"
            scroll={{ x: true }}
            style={{ width: "100%" }}
          />,
        ],
      )}
    </Flex>
  )
})
